import apiClient from "../apiClient";
import {
  MeetingQuizStatusSchema,
  QuizListResponse,
  QuizAttemptSchema,
  QuizAttemptResponse,
} from "@/types/quiz.types";

/**
 * Inicia a geração do quiz para uma reunião
 */
export const generateQuiz = async (meetingId: string): Promise<{ status: string; message: string }> => {
  const response = await apiClient.post<{ status: string; message: string }>(
    `/teacher/meeting/${meetingId}/generate-quiz`
  );
  return response;
};

/**
 * Verifica o status da geração do quiz
 */
export const checkQuizStatus = async (meetingId: string): Promise<MeetingQuizStatusSchema> => {
  const response = await apiClient.get<MeetingQuizStatusSchema>(
    `/teacher/meeting/${meetingId}/generate-quiz`
  );
  return response;
};

/**
 * Busca as perguntas do quiz gerado
 */
export const getQuizQuestions = async (meetingId: string): Promise<QuizListResponse> => {
  const response = await apiClient.get<QuizListResponse>(
    `/teacher/meeting/${meetingId}/quiz`
  );
  return response;
};

/**
 * Envia uma tentativa de resposta para uma pergunta do quiz
 */
export const submitQuizAttempt = async (data: QuizAttemptSchema): Promise<QuizAttemptResponse> => {
  const response = await apiClient.post<QuizAttemptResponse>(
    `/teacher/quiz/attempt`,
    data
  );
  return response;
};
